export class AssociazioneDTO {
  denominazione: string;

  cf: string;
}
